import { differenceInDays } from 'date-fns';

export const dateInputDateFormat = 'MM/dd/yyyy';

export function getDaysRemaining(expiryDate: string | null | undefined) {
  if (expiryDate) {
    const expiration = new Date(expiryDate);
    return differenceInDays(expiration, new Date());
  }
  return -1;
}
